var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.invoiceState !== null)?_c('v-chip',{staticClass:"invoice-badge white--text",attrs:{"small":"","color":_vm.invoiceColor}},[_vm._v(_vm._s(_vm.invoiceText))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }